export default "__VITE_ASSET__YdcbxT7m__"